import {ActionTypes} from '../actions';
import {Forms} from '../../common/actionTypes';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'loadingChassisInfo': false,
  'chassisInfo': {},
  'downloading': false,
  'urlFile': '',
};

export const vehicleEfficiency = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_VEHICLES_EFFICIENCY]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'downloading': false,
      'urlFile': '',
    }),
    [ActionTypes.FETCHING_VEHICLES_EFFICIENCY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLES_EFFICIENCY]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLES_EFFICIENCY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_CHASSIS_INFO]: (state) => ({
      ...state,
      'loadingChassisInfo': false,
      'chassisInfo': {},
    }),
    [Forms.FETCHING_CHASSIS_INFO]: (state) => ({
      ...state,
      'loadingChassisInfo': true,
    }),
    [Forms.FETCHED_CHASSIS_INFO]: (state, action) => ({
      ...state,
      'loadingChassisInfo': false,
      'chassisInfo': action.response.data,
    }),
    [Forms.FETCHED_CHASSIS_INFO_FAILED]: (state) => ({
      ...state,
      'loadingChassisInfo': false,
      'chassisInfo': {},
    }),
    [ActionTypes.CLEAR_URL_VEHICLES_EFFICIENCY]: (state) => ({
      ...state,
      'downloading': false,
      'urlFile': '',
    }),
    [ActionTypes.DOWNLOADING_VEHICLES_EFFICIENCY]: (state) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_VEHICLES_EFFICIENCY]: (state) => ({
      ...state,
      'downloading': false,
      'urlFile': action.response.data,
    }),
    [ActionTypes.DOWNLOADED_VEHICLES_EFFICIENCY_FAILED]: (state) => ({
      ...state,
      'downloading': false,
      'urlFile': '',
    }),
  })(state, action);
};
